export default "__VITE_ASSET__3ea10c5d__"